import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const ThemeSelector = () => {
  const { mode, toggleMode } = useTheme();

  return (
    <div className="relative">
      <div className="flex items-center gap-2">
        {/* Theme Toggle (Light/Dark) */}
        <button
          onClick={toggleMode}
          className={`p-2 rounded-lg transition-colors ${
            mode === 'dark' 
              ? 'text-gray-400 hover:text-white hover:bg-slate-700' 
              : 'text-gray-600 hover:text-gray-900 hover:bg-teal-100'
          }`}
          title={mode === 'dark' ? 'Mudar para modo claro' : 'Mudar para modo escuro'}
        >
          {mode === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
        </button>
      </div>
      {/* Palette selector temporariamente removido */}
    </div>
  );
};

export default ThemeSelector;
